var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"counter__wrapper"},_vm._l((_vm.getValString),function(char,index){return _c('span',{key:index,class:{ counter__animate: char != '.' }},[_vm._v("\n    "+_vm._s(char)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }